import { motion, AnimatePresence } from 'framer-motion'
import { Loader2 } from 'lucide-react'

export default function MeetingSetupOverlay({
  visible,
  title = 'Setting Up Rithmo',
  subtitle = 'Preparing your meeting environment',
}) {
  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.25 }}
          className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 backdrop-blur-sm"
        >
          <motion.div
            initial={{ opacity: 0, scale: 0.95, y: 10 }}
            animate={{ opacity: 1, scale: 1, y: 0 }}
            exit={{ opacity: 0, scale: 0.95, y: 10 }}
            transition={{ duration: 0.3, ease: 'easeOut' }}
            className="bg-white rounded-2xl shadow-xl p-6 sm:p-10 flex flex-col items-center gap-5 max-w-sm mx-4"
          >
            <div className="w-14 h-14 rounded-2xl bg-gradient-primary flex items-center justify-center">
              <Loader2 className="w-7 h-7 text-white animate-spin" />
            </div>
            <div className="text-center space-y-2">
              <h2 className="text-xl font-semibold text-gray-900 animate-pulse">
                {title}
              </h2>
              <p className="text-sm text-gray-500">{subtitle}</p>
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  )
}
